import PropTypes from 'prop-types';

import styles from './TaskLayout.module.scss';

const TaskLayout = ({ children }) => <section className={styles.taskLayout}>{children}</section>;

TaskLayout.propTypes = {
  children: PropTypes.node,
};

TaskLayout.defaultProps = {
  children: <div />,
};

export default TaskLayout;
